import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Home, Phone, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen flex items-center">
      <Helmet>
        <title>Seite nicht gefunden - Easy Vertrag</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <span className="text-8xl font-bold text-gray-200 select-none">404</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Diese Seite existiert nicht
          </h1>
          <p className="text-lg text-gray-600 mb-10">
            Die gesuchte Seite wurde nicht gefunden. Vielleicht wurde sie verschoben oder der Link ist veraltet.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              <Home className="w-5 h-5" />
              Zur Startseite
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
            >
              <Phone className="w-5 h-5" />
              Kontakt aufnehmen
            </Link>
          </div>
          <div className="mt-10">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              Zuruck zur vorherigen Seite
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
